import { useState } from 'react';
import './style.scss';
import PressReleasesTabPanel from './components/PressReleaseTabPanel';
import PressMaterialTabPanel from './components/PressMaterialTabPanel';
import PressContactsTabPanel from './components/PressContactsTabPanel';
import { TranslationService } from '../../services/translation.service';
import TabList from '../Shared/TabList';
import TabListNavItem from '../Shared/TabList/components/TabListNavItem';
import TabListTabContent from '../Shared/TabList/components/TabListTabContent';

enum PressPageTabType {
  None = 'none',
  PressReleases = 'pressreleases',
  PressMaterial = 'pressmaterial',
  Contacts = 'contacts',
}

function PressPage() {
  const [selectedTab, setSelectedTab] = useState(PressPageTabType.PressReleases);

  function handleTabListSelectedChange(index: number) {
    if (index === 0) setSelectedTab(PressPageTabType.PressReleases);
    else if (index === 1) setSelectedTab(PressPageTabType.PressMaterial);
    else setSelectedTab(PressPageTabType.Contacts);
  }

  function getActiveIndex() {
    switch (selectedTab) {
      case PressPageTabType.PressReleases:
        return 0;
      case PressPageTabType.PressMaterial:
        return 1;
      case PressPageTabType.Contacts:
        return 2;
      default:
        return 0;
    }
  }

  return (
    <div className="press-page-component">
      <TabList
        id="nav-press-releases"
        activeIndex={getActiveIndex()}
        onSelectedChange={handleTabListSelectedChange}
        renderTabsAsDropdownOnMobile={true}
        dropDownLabelledBy="press-page-heading"
        navItems={[
          <TabListNavItem key={'nav-item-0'} onActivate={() => setSelectedTab(PressPageTabType.PressReleases)}>
            {TranslationService.get('presspage.pressreleases')}
          </TabListNavItem>,
          <TabListNavItem key={'nav-item-1'} onActivate={() => setSelectedTab(PressPageTabType.PressMaterial)}>
            {TranslationService.get('presspage.pressmaterial')}
          </TabListNavItem>,
          <TabListNavItem key={'nav-item-2'} onActivate={() => setSelectedTab(PressPageTabType.Contacts)}>
            {TranslationService.get('presspage.contacts')}
          </TabListNavItem>,
        ]}
        tabContents={[
          <TabListTabContent key={'tab-item-0'}>
            <>
              <h2 className="visually-hidden">{TranslationService.get('presspage.pressreleases')}</h2>
              <PressReleasesTabPanel active={selectedTab === PressPageTabType.PressReleases} />
            </>
          </TabListTabContent>,
          <TabListTabContent key={'tab-item-1'}>
            <>
              <h2 className="visually-hidden">{TranslationService.get('presspage.pressmaterial')}</h2>
              <PressMaterialTabPanel active={selectedTab === PressPageTabType.PressMaterial} />
            </>
          </TabListTabContent>,
          <TabListTabContent key={'tab-item-2'}>
            <>
              <h2 className="visually-hidden">{TranslationService.get('presspage.contacts')}</h2>
              <PressContactsTabPanel active={selectedTab === PressPageTabType.Contacts} />
            </>
          </TabListTabContent>,
        ]}
      ></TabList>
    </div>
  );
}

export default PressPage;
